if (!customElements.get('policy-pages')) {
  customElements.define('policy-pages', class extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('.pp__menu');
      if (!this.menu || this.teardown) return;
      const media = matchMedia('(min-width: 990px)');
      const updateMenu = () => {
        this.menu.open = media.matches || this.dataset.collapseMobile !== 'true';
      };
      updateMenu();
      media.addEventListener('change', updateMenu);
      const cleanups = [() => media.removeEventListener('change', updateMenu)];
      if (this.dataset.sticky === 'true' || this.dataset.stickyMobile === 'true') {
        let selector = this.dataset.headerSelector.trim();
        const useLive = !selector && getComputedStyle(document.documentElement).getPropertyValue('--header-height-live').trim();
        if (!useLive) {
          selector ||= '.section-header, .shopify-section-group-header-group, sticky-header';
          let headers;
          try { headers = [...document.querySelectorAll(selector)]; } catch { headers = []; }
          let frame = 0;
          const measure = () => {
            frame = 0;
            let offset = 0;
            for (const header of headers) {
              if (header.closest('.shopify-section-header-hidden, [hidden]')) continue;
              const style = getComputedStyle(header);
              if (style.display === 'none' || style.visibility === 'hidden') continue;
              const rect = header.getBoundingClientRect();
              if (!rect.width || !rect.height) continue;
              if (style.position === 'fixed' || style.position === 'sticky') {
                const top = Math.max(0, parseFloat(style.top) || 0);
                if (rect.top <= top + 1 || header.classList.contains('shopify-section-header-sticky')) {
                  offset = Math.max(offset, rect.bottom, top + rect.height);
                }
              }
            }
            this.style.setProperty('--pp-header', `${Math.ceil(Math.min(innerHeight, Math.max(0, offset)))}px`);
          };
          const schedule = () => { if (!frame) frame = requestAnimationFrame(measure); };
          const mutation = new MutationObserver(schedule);
          const resize = new ResizeObserver(schedule);
          headers.forEach(header => {
            mutation.observe(header, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
            resize.observe(header);
          });
          window.addEventListener('scroll', schedule, { passive: true });
          window.addEventListener('resize', schedule, { passive: true });
          measure();
          cleanups.push(() => {
            mutation.disconnect();
            resize.disconnect();
            cancelAnimationFrame(frame);
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
          });
        }
      }
      this.teardown = () => cleanups.forEach(cleanup => cleanup());
    }
    disconnectedCallback() {
      this.teardown?.();
      this.teardown = null;
    }
  });
}
